import { render } from "./FramesGame.vue?vue&type=template&id=858938e8&scoped=true"
import script from "./FramesGame.vue?vue&type=script&lang=js"
export * from "./FramesGame.vue?vue&type=script&lang=js"

import "./FramesGame.vue?vue&type=style&index=0&id=858938e8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-858938e8"]])

export default __exports__